<template>
  <div>
    <div id="app" class="mt-4 ml-3 view">
      <!--      <div class="name" @click="$router.replace('/')">-->
      <!--        <h1 class="font-weight-light text-left ml-5">Anton von Heiseler</h1>-->
      <!--        <h4 class="mt-0 text-left subtitle ml-5">Filmmaker</h4>-->
      <!--      </div>-->

      <nav class="navbar navbar-expand-lg navbar-light">
        <a class="h2 font-weight-bold pr-4 pointer" @click="$router.push('/')">Anton von Heiseler</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav">

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">
                Films
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link to="/153METER/" class="dropdown-item text-uppercase"> 153 METER <span class="date">2022</span></router-link>
                <router-link to="/mountainmaiden/" class="dropdown-item text-uppercase">Mountain & Maiden <span class="date">2020</span></router-link>
                <router-link to="/postmortem/" class="dropdown-item text-uppercase"> Post Mortem <span class="date">(2019)</span></router-link>
                <router-link to="/blackmountain/" class="dropdown-item text-uppercase">The Black Mountain <span class="date">2018</span></router-link>
                <router-link to="/untitled/" class="dropdown-item text-uppercase">untitled <span class="date">2019</span></router-link>
                <router-link to="/derigel/" class="dropdown-item text-uppercase">Der Igel <span class="date">2019</span></router-link>
                <router-link to="/premedicatedmurder/" class="dropdown-item text-uppercase">Premdicated Murder <span class="date">2015</span></router-link>

              </div>
            </li>
          </ul>
        </div>
      </nav>

      <div class="row">
        <!--        <div class="col-11 col-lg-3 ml-lg-5 ml-3 mr-3 mr-lg-0 mt-4 mb-3 mb-lg-0">-->
        <!--          <div class="navigation p-4">-->
        <!--            <h4 class="text-center filmography-head pb-2 pt-2 font-weight-light">FILMOGRAPHY</h4>-->
        <!--            <nav class="nav flex-column mt-3">-->
        <!--              <router-link to="/" class="nav-link text-uppercase" > Post Mortem <span class="date">(AT)</span></router-link>-->
        <!--              <router-link to="/blackmountain/" class="nav-link text-uppercase" >The Black Mountain <span class="date">2018</span></router-link>-->
        <!--              <router-link to="/premedicatedmurder/" class="nav-link text-uppercase" >Premdicated Murder <span class="date">2015</span></router-link>-->
        <!--              <router-link to="/identitaet/" class="nav-link text-uppercase" >Identität <span class="date">2008</span></router-link>-->
        <!--              <router-link to="/trashytrash/" class="nav-link text-uppercase" >Trashy Trash <span class="date">2008</span></router-link>-->
        <!--            </nav>-->
        <!--          </div>-->

        <!--        </div>-->


        <div class="col mr-5">
          <div class="container-fluid mt-3">
            <router-view/>
          </div>


        </div>
      </div>


    </div>
    <div class="text-center mt-5">
      <span>Copyright © 2022 Anton von Heiseler</span>
      <router-link to="/imprint/" class="nav-link text-uppercase"> Impressum</router-link>
    </div>
  </div>

</template>
<script>
export default {
  metaInfo: {
    title: "Anton von Heiseler",
    meta: [
      {name: 'description', content: 'Anton von Heiseler, Director'}
    ]
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap');

.view {
  min-height: 100vh;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe, .embed-container object, .embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

body {
  font-family: 'Roboto', sans-serif;
}

a {
  color: #2C3A47;
}

a:hover {
  color: #6d214f;

}


.nav-link {
  color: #2C3A47;
  font-size: 20px;
}

.nav-link:hover {
  color: #6d214f;
}

.subtitle {
  padding-bottom: 10px;
  /*border-bottom: 1px solid #d8d8d8;*/
}

.navigation {
  top: 35px;
  border: 1px solid #d8d8d8;
  position: sticky;
  position: -webkit-sticky;
}

.filmography-head {
  border-bottom: 1px solid #d8d8d8;
}

.name {
  cursor: pointer;
}

.date {
  font-size: 70%;
}

.pointer:hover {
  cursor: pointer;
}
</style>
